import { Component } from '@angular/core';

@Component({
    selector: 'pdf-edit-signature-dialog',
    templateUrl: './pdf-edit-signature-dialog.component.html',
    styleUrl: './pdf-edit-signature-dialog.component.css',
    standalone: false
})
export class EditSignatureDialogComponent {}
